export enum aspNetControl
{
	Label = 1,
	TextBox = 2,
	Image_Button = 3,
	DropDownList = 4,
	List_Item = 5,
	CheckBoxList = 6,
	RadioButtonList = 7,
	Image = 8,
	Required_Field_Validator = 11,
	Radio_List_Validator = 12,
	New_Line = 13,
	Custom_Field_Validator = 15,
	User_Defined_Amount = 16,
	Ordered_List = 17,
	Radio_List_Validation = 18,
	Date_Validator = 19,
	List_Other = 24,
	CheckBoxListRepeatColumns = 25,
	States_List = 26,
	Repeating_Section = 27,
	Hidden = 28,
}
